// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* 배너 높이만큼 화면을 내림(사이드 메뉴가 position: fixed 라 같이 내림) */\nbody.support-mode {\n  padding-top: 36px;\n}\nbody.support-mode .fixed-start {\n  top: 36px !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
